import {NavPathInfo, PlaceInfo} from '@findhotel/sapi'

interface SeoPlace extends Partial<PlaceInfo> {
  id: string
  name?: string
}

interface AnchorSeoMetadata {
  country: SeoPlace | null
  city: SeoPlace | null
  landmark: SeoPlace | null
}

/**
 * Extracts metadata from navPathInfo and placeName to be used in SEO.
 * This allows reusing the function with different data sources (e.g., seo-db places).
 * @param placeId - The place ID
 * @param navPathInfo - Navigation path info containing country and city
 * @param placeName - The place name (used for landmarks)
 * @returns AnchorSeoMetadata
 */
export const extractMetadataFromNavPathInfo = (
  placeId: string,
  navPathInfo?: NavPathInfo,
  placeName?: string
): AnchorSeoMetadata => {
  if (!placeId || !navPathInfo) {
    return {country: null, city: null, landmark: null}
  }

  const {country, city} = navPathInfo

  const landmark = {id: placeId, name: placeName}
  const hasLandmark = placeId !== country?.id && placeId !== city?.id

  const isValid = (entity?: PlaceInfo) => {
    return Boolean(entity?.name?.trim())
  }

  return {
    country: isValid(country) ? country : null,
    city: isValid(city) ? city : null,
    landmark: hasLandmark && isValid(landmark) ? landmark : null
  }
}
